var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    {
      staticClass: "text-caption transparent flex-shrink-1 px-4 max-width",
      class:
        _vm.contentClass +
        (_vm.left
          ? " text-left"
          : _vm.center
          ? " text-center"
          : _vm.right
          ? " text-right"
          : " text-center"),
      style: { color: _vm.fontColor, maxWidth: _vm.maxWidth },
      attrs: { height: "40" },
    },
    [
      _vm._v(
        " © " +
          _vm._s(_vm.curYear) +
          " " +
          _vm._s(_vm.$t("label_essweb_footer_components_brandLabel")) +
          " "
      ),
      _c(
        "span",
        {
          class: _vm.linkReverse ? "white--text" : "primary--text",
          staticStyle: { cursor: "pointer" },
          on: {
            click: function ($event) {
              return _vm.toText("https://privacy.essencehr.io/")
            },
          },
        },
        [
          _vm._v(
            _vm._s(_vm.$t("label_essweb_footer_components_privacyPolicyLabel"))
          ),
        ]
      ),
      _vm._v(
        " " + _vm._s(_vm.$t("label_essweb_footer_components_andLabel")) + " "
      ),
      _c(
        "span",
        {
          class: _vm.linkReverse ? "white--text" : "primary--text",
          staticStyle: { cursor: "pointer" },
          on: {
            click: function ($event) {
              return _vm.toText("https://terms.essencehr.io/")
            },
          },
        },
        [
          _vm._v(
            _vm._s(_vm.$t("label_essweb_footer_components_termOfUseLabel"))
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }